import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ValidationSummary } from "devextreme-react/validation-summary";
import {
	EnterServiceDatePanel,
	ExitButton,
	PrintButton,
	PurchaseOrderAddNoteButton,
	PurchaseOrderCards,
	PurchaseOrderFilesButton,
	PurchaseOrderNotesPanel,
	PurchaseOrderPage,
	PurchaseOrderProducts,
	PurchaseOrderProgress,
	PurchaseOrderProgressStep,
	SaveButton
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';

export default function PurchaseOrderServiceDatePage() {

	return (

		<PurchaseOrderPage>

			<PurchaseOrderCards showCustomerInfo={true} />

			<PurchaseOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={PurchaseOrderProgressStep.EnterServiceDate} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PurchaseOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<PurchaseOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<EnterServiceDatePanel />
				</Item>
				<Item ratio={1}>
					<PurchaseOrderNotesPanel height={200} />
				</Item>
			</Box>

			<PurchaseOrderProducts />

		</PurchaseOrderPage>
	)
}
